import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useConfig } from "src/hooks/config";
import Money from "src/common/components/money";
import { getBetCalculations } from "calculation";
import upperDataStore from "src/stores/upperData";
import selectionsStore from "src/stores/selections";
import { useTranslation } from "src/hooks/translation";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations";
import mainStore from "src/stores/main";
import { BetTypeEnum } from "src/constants/enums/betType";
interface IProps {
	stake: number;
}

const BetDetailsMinPossibleWin = ({ stake }: IProps) => {
	const t = useTranslation();
	const config = useConfig();
	const { betType, systemCombinationCount } = useRecoilValue(mainStore);
	const { partnerConfig, currencyConfig } = useRecoilValue(upperDataStore);
	const { selections } = useRecoilValue(selectionsStore);

	const { minPossibleWin } = useMemo(
		() =>
			getBetCalculations([BetCalculationsEnum.MinPossibleWin], {
				config,
				partnerConfig,
				stake: +stake,
				events: selections,
				systemCombinationCount,
				currencyConfig,
			}),
		[config, partnerConfig, currencyConfig, stake, selections, systemCombinationCount]
	);

	if (!minPossibleWin || betType !== BetTypeEnum.System) return null;

	return (
		<div className="B-betslip-bet-details-info-row">
			<p className="B-info-row-title">{t("Min possible win")}:</p>
			<p className="B-info-row-number">
				<Money amount={minPossibleWin} />
			</p>
		</div>
	);
};

export default BetDetailsMinPossibleWin;
